import { gql } from '@apollo/client';
import { TaxjarCategoryInfo } from '../fragments';

export default gql`
  query TaxjarCategories($active: Boolean, $search: String) {
    taxjarCategories(active: $active, search: $search) {
      ...TaxjarCategoryInfo
    }
  }
  ${TaxjarCategoryInfo}
`;
